import resolveImage from './resolveImage';
import resolveRTC from './resolveRTC';

export type PersonProps = { rawVal?: Br.Reference };
const resolvePerson = ({ rawVal, page }: PropsWithCMSProps<PersonProps>) => {
  const content = rawVal && page?.getContent(rawVal);
  const { phoneNumber, personName, title, company, bio, image, email } =
    content?.getData<PersonDocType>() || {};
  return {
    phoneNumber,
    name: personName,
    title,
    company,
    bio: resolveRTC({ rawVal: bio }),
    image: resolveImage({ rawVal: image, page }),
    email,
  } as PersonType;
};

export default resolvePerson;
